// Bridges ui.ts's cast handler to GameScene for a Separate·Momentum cast --
// releases an existing Bind·Momentum link (see bindEffect.ts). Bind creates
// the coupling, Separate undoes it, the same create/undo shape the operator
// pair already has for Mass (fuse) vs. Mass·Reverse (remerge).
//
// The event/result shapes themselves live in rune-lab/src/sim/casts.ts with the
// handler that consumes them, and are re-exported here unchanged, so every
// import site reads them from this module -- the same shape every other
// operator effect's bridge already has.
import { UnbindEffectEvent, UnbindEffectResult } from '../../rune-lab/src/sim/casts';

export type { UnbindEffectEvent, UnbindEffectResult };

type Handler = (event: UnbindEffectEvent) => UnbindEffectResult;

let handler: Handler | null = null;

export function onUnbindEffect(fn: Handler): void {
  handler = fn;
}

export function triggerUnbindEffect(event: UnbindEffectEvent): UnbindEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '' };
}
